import { em } from '@mantine/core';
import { memo } from 'react';
import styled from 'styled-components';

interface Props {
	top?: React.ReactNode;
	middle?: React.ReactNode;
	bottom?: React.ReactNode;
}

const CarouselItem = ({ top, middle, bottom }: Props) => {
	return (
		<Container>
			{top}
			{middle}
			{bottom}
		</Container>
	);
};
const Container = styled.div`
	display: flex;
	gap: ${em(16)};
	flex-direction: column;
`;
const _CarouselItemExport = memo(CarouselItem);

export { _CarouselItemExport as CarouselItem };
